export default {
  name: "fixed",

  mounted(element, binding) {
    element.style = "position: fixed; z-index: 9999";
    element.style.top = binding.value + "px";
  },
};
